import ModalOverlay from './ModalOverlay.js';

/**
 * Create a confirm dialog
 *
 * @param {String} title The title of the dialog
 * @param {Node} bodyContent The contents of the dialog
 * @param {String} positiveLabel The label of the button with the positive action.
 *        Defaults to "OK". When this button is activated, `onDismiss` will be called
 *        with "ok" as the `reason`.
 * @param {String} negativeLabel The label of the button with the negative action
 *        Defaults to "Cancel". When this button is activated, `onDismiss` will be called
 *        with "cancel" as the `reason`.
 * @param {Object} options Passed directly to ModalOverlay
 */
class ConfirmDialog extends ModalOverlay {
    constructor(
        title,
        bodyContent,
        positiveLabel = 'OK',
        negativeLabel = 'Cancel',
        options = {}
    ) {
        super(title, bodyContent, options);
        this._bodyContent = bodyContent;
        this.positiveButton = null;
        this.negativeButton = null;

        if (negativeLabel) {
            this.negativeButton = this._buildButton(
                negativeLabel,
                ConfirmDialog.NEGATIVE_LABEL
            );
            this.negativeButton.setAttribute('data-autofocus', '');
        }

        if (positiveLabel) {
            this.positiveButton = this._buildButton(
                positiveLabel,
                ConfirmDialog.POSITIVE_LABEL
            );
        }
    }

    _buildContent() {
        const toolbarTitle = [
            this._buildTableCell(this._buildTitle(), 'centerify'),
        ];
        const titleEle = this._buildTitle();
        titleEle.classList.add('hidegt768', 'u-hide-gt768');
        const toolbarContent = [
            this._buildTableCell(this.negativeButton),
            this._buildTableCell(titleEle, 'centerify'),
            this._buildTableCell(this.positiveButton, 'rightify'),
        ];
        const frag = document.createDocumentFragment();
        frag.appendChild(this._buildToolbar(...toolbarTitle));
        const toolbarEle = this._buildToolbar(...toolbarContent);
        toolbarEle.classList.add('app-toolbar-modal-buttonrow');
        frag.appendChild(toolbarEle);
        frag.appendChild(this._buildBodyContent());
        return frag;
    }

    _buildToolbar(...content) {
        const toolbarEle = document.createElement('div');
        toolbarEle.className = 'app-toolbar-modal';
        const topbarEle = document.createElement('div');
        topbarEle.className = 'display-table fit-height phm';
        topbarEle.append(...content);
        toolbarEle.append(topbarEle);
        return toolbarEle;
    }

    _buildTitle() {
        const titleEle = document.createElement('h2');
        titleEle.textContent = this._title;
        titleEle.className = 'truncate man t3 u-truncate u-t3 u-ma0';
        return titleEle;
    }

    _buildBodyContent() {
        const ele = document.createElement('div');
        ele.className = 'scroll-container';
        ele.appendChild(this._bodyContent);
        return ele;
    }

    _buildTableCell(node, className) {
        const tableCell = document.createElement('div');
        tableCell.className = 'display-cell';
        tableCell.setAttribute('role', 'presentation');

        if (className) {
            tableCell.classList.add(className);
        }

        if (typeof node == 'string') {
            node = document.createTextNode(node);
        }

        if (node) {
            tableCell.appendChild(node);
        }
        return tableCell;
    }

    _buildButton(label, reason = label.toLowerCase()) {
        const ele = document.createElement('button');
        if (reason === 'ok') {
            ele.className = 'primary pvs button button--cta';
        } else {
            ele.className = 'blank pvs pln button button--flat';
        }
        ele.textContent = label;
        ele.addEventListener('click', event => {
            event.stopPropagation();
            this.dismiss(reason);
        });
        return ele;
    }
}

ConfirmDialog.POSITIVE_LABEL = 'ok';
ConfirmDialog.NEGATIVE_LABEL = 'cancel';

export default ConfirmDialog;



// WEBPACK FOOTER //
// ./lib/ConfirmDialog.js